import { render, staticRenderFns } from "./DecimalNumber.vue?vue&type=template&id=2c6bcb8c&scoped=true&"
import script from "./DecimalNumber.vue?vue&type=script&lang=js&"
export * from "./DecimalNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6bcb8c",
  null
  
)

export default component.exports